var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 5C15.866 5 19 8.13401 19 12C19 15.866 15.866 19 12 19C8.13401 19 5 15.866 5 12C5 8.13401 8.13401 5 12 5ZM10.0107 12.5C10.063 14.1231 10.364 15.5434 10.7979 16.5557C11.0375 17.1149 11.2977 17.5039 11.5352 17.7383C11.7682 17.9681 11.924 18 12 18C12.076 18 12.2318 17.9681 12.4648 17.7383C12.7023 17.5039 12.9625 17.1149 13.2021 16.5557C13.636 15.5434 13.937 14.1231 13.9893 12.5H10.0107ZM6.02246 12.5C6.22859 14.9978 7.96328 17.0602 10.29 17.751C9.56573 16.5759 9.07459 14.6753 9.00879 12.5H6.02246ZM14.9912 12.5C14.9254 14.6756 14.4334 16.5759 13.709 17.751C16.0362 17.0605 17.7714 14.9981 17.9775 12.5H14.9912ZM10.29 6.24805C7.96315 6.93875 6.2286 9.00212 6.02246 11.5H9.00879C9.0746 9.32423 9.56549 7.42306 10.29 6.24805ZM12 6C11.924 6 11.7682 6.03186 11.5352 6.26172C11.2977 6.49608 11.0375 6.88507 10.7979 7.44434C10.364 8.4566 10.063 9.87694 10.0107 11.5H13.9893C13.937 9.87694 13.636 8.4566 13.2021 7.44434C12.9625 6.88507 12.7023 6.49608 12.4648 6.26172C12.2318 6.03186 12.076 6 12 6ZM13.709 6.24805C14.4337 7.42303 14.9254 9.32396 14.9912 11.5H17.9775C17.7714 9.00179 16.0363 6.93848 13.709 6.24805Z",
    fill: "black",
    fillOpacity: 0.9
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.fdc18c222ddc1e48413bd009476979d2.svg";
export { ForwardRef as ReactComponent };